<template>
    <div >
        <Card style="margin: 12px 0;">
              <p slot="title"> Marking TOP </p>
              <Row type="flex" justify="space-between">
                <Col span="10">
                  <Select v-model="topColorSelected"
                          placeholder="Pilih Warna TOP"
                          clearable
                          filterable>
                    <Option v-for="topColor in topColors"
                            :value="topColor.color"
                            :key="topColor.color">
                      {{ topColor.color }}
                    </Option>
                  </Select>
                </Col>

                <Col span="10">
                    <ButtonGroup class="custom-group-parent">
                        <Button class="custom-group">Marking &nbsp;&nbsp;&nbsp;</Button>
                        <Select
                            style="width: 100%;"
                            v-model="markingIdSelected"
                            filterable
                            clearable
                            :remote-method="getMarkingByCode"
                            :loading="loadingSearch"
                            @on-change="updateFilter">
                            <Option v-for="option in optionMarkings"
                                :value="option.value" :key="option.value">{{option.label}}</Option>
                        </Select>
                    </ButtonGroup>
                </Col>
                <Col span="3">
                    <Button type="primary" icon="ios-search" @click="getMarkingTOP" :disabled="!isSearchShow">
                      <span>Cari</span>
                    </Button>
                </Col>
                <Col span="2">
                    <Spin size="large" v-show="loadingSearch"></Spin>
                </Col>
              </Row>
              <br />
              <!-- <Alert type="info" show-icon>Claim yang berwarna merah berarti, data tersebut sudah dihapus dari pembayaran</Alert> -->
        </Card>
        <Card>
              <template>
                  <Table border :columns="columnTableMarking" :data="topMarkingDatas"></Table>
              </template>
        </Card>
        <template>
            <Modal v-model="modal.editTop" width="500px">
                <p slot="header" style="color:#f60;text-align:center">
                    <Icon type="information-circled"></Icon>
                    <span>Change Color</span>
                </p>
                <Form>
                    <Form-item label="Top Color" prop="color">
                         <Select v-model="topColorEdit"
                                placeholder="Pilih Warna TOP"
                                clearable
                                filterable>
                          <Option v-for="topColor in topColors"
                                  :value="topColor.color"
                                  :key="topColor.color">
                            {{ topColor.color }}
                          </Option>
                        </Select>
                    </Form-item>
                </Form>
                <div slot="footer">
                    <Button v-show="true" type="primary" :loading="loadingSearch" @click="postUpdateColor">
                        <span v-if="!loadingSearch">Edit</span>
                        <span v-else>Wait.....</span>
                    </Button>
                </div>
            </Modal>
        </template>
    </div>
</template>

<script>
import {HTTP} from '@/components/http-lib'
import _ from 'lodash'

export default {
    data () {
        return {
            modal: {
                editTop: false,
            },
            loadingSearch: false,
            markingIdSelected : null,
            topColorSelected : null,
            optionMarkings: [],
            topMarkingDatas: [],
            isSearchShow: false,
            topColorEdit: null,
            topColors: [
                { color: 'GREEN' },
                { color: 'YELLOW' },
                { color: 'RED' }
            ],
            columnTableMarking: [
                {
                    title: 'Marking Code',
                    key: 'markingheadercode',
                },
                {
                    title: 'TOP Color',
                    key: 'top_color',
                    render: (h, params) => {
                    const color = params.row.top_color
                    return h('div', {
                      style: {
                        backgroundColor: color ? color : 'transparent',
                        color: color ? '#000' : '#000',
                        padding: '4px 8px',
                        borderRadius: '4px',
                        textAlign: 'center'
                      }
                    }, color || '-')
                  }
                },
                {
                    title: 'Action',
                    key: 'action',
                    width: 150,
                    align: 'center',
                    render: (h, params) => {
                        return h('div', [
                            h('Button', {
                                props: {
                                    type: 'success',
                                    size: 'small'
                                },
                                style: {
                                    marginRight: '5px'
                                },
                                on: {
                                    click: () => {
                                        this.show(params.index)
                                    }
                                }
                            }, 'Edit')
                        ]);
                    }
                }
            ],
        }
    },

  methods: {
    getMarkingByCode: _.debounce(
        function (query) {
            if (query !== '') {
                this.loadingGetMarking = true;
                HTTP
                // .post('marking/getByCodeAll', {
                .post('marking/getBySnapshot', {
                    markingHeaderId: query,
                    subbranchcode: this.subbranchcode
                })
                .then(response => {
                    this.loadingGetMarking = false;
                    let data = response.data;

                    const list = data.map(item => {
                        return {
                            value: item.markingheaderid,
                            label: item.markingheadercode
                        };
                    });

                    this.optionMarkings = list.filter(item => item.label.toLowerCase().indexOf(query.toLowerCase()) > -1);
                })
                .catch(e => {
                    this.loadingGetMarking = false;
                    this.$Notice.error({
                        title: "Error",
                        desc: e,
                        duration: 5
                    });
                })
            } else {
                this.optionMarkings = [];
            }
        }, 400
    ),
    updateFilter: function () {
            const markingHeaderId = this.markingIdSelected
            const topColor = this.topColorSelected

            if (markingHeaderId == null && topColor == null) {
                this.isSearchShow = false
            } else {
                this.isSearchShow = true
            }
        },
    getMarkingTOP: function () {
          this.loadingSearch = true;

          let payload = {
              marking_header_id: this.markingIdSelected,
              top_color: this.topColorSelected
          }

          HTTP.post('marking-top', payload)
            .then(response => {
              this.topMarkingDatas = response.data.data;
              console.log(this.topMarkingDatas);

              this.loadingSearch = false;
          })
          .catch(e => {
              this.loadingSearch = false;
              this.$Notice.error({
                  title: "Error",
                  desc: e,
                  duration: 5
              });
          });
      },
      show: function(index){
          var top_color = this.topMarkingDatas[index].top_color;

          this.topColorEdit = top_color;
          this.modal.editTop = true;
      },
      postUpdateColor: function () {
        HTTP
          .post('marking-top/update', {
              marking_header_id: this.markingIdSelected,
              top_color: this.topColorEdit
          })
          .then(response => {
              this.getMarkingTOP();
              this.modal.editTop = false;
          })
          .catch(e => {
              this.modal.editTop = false;
              this.$Notice.error({
                  title: "Error",
                  desc: e,
                  duration: 5
              });
          })
      },
   },
}
</script>
<style>

</style>



// WEBPACK FOOTER //
// MarkingTop.vue?be14a322